module.exports = __webpack_public_path__ + "img/inactive_arrow_left.929b7564.svg";